/**
 * 依副檔名對圖示。跟 index.tsx 分開只因為 webpack context 跟對照表很吵，不是第三層架構。
 */

// CRA/webpack：把該資料夾全部 PNG 打進 bundle。
// eslint-disable-next-line @typescript-eslint/no-var-requires
const iconContext = (require as any).context(
  '../../../image/iconHandler',
  false,
  /\.png$/
);

const iconByKey: Record<string, string> = {};
iconContext.keys().forEach((key: string) => {
  // "./pdf.png" -> "pdf"
  const base = key.replace(/^\.\//, '').replace(/\.png$/i, '').toLowerCase();
  iconByKey[base] = iconContext(key);
});

const FILE_FALLBACK = iconByKey['file'] || iconByKey['file.png'];
const FOLDER_ICON =
  iconByKey['foldertree'] ||
  iconByKey['foldertree2'] ||
  iconByKey['bkfoldertree'] ||
  FILE_FALLBACK;

/** 常見副檔名對到 iconHandler 資料夾裡的檔名（不含 .png）。 */
const EXT_ALIASES: Record<string, string> = {
  jpeg: 'jpg',
  jpe: 'jpg',
  jfif: 'jpg',
  js: 'javascript',
  mjs: 'javascript',
  cjs: 'javascript',
  json: 'json-file',
  htm: 'html',
  xhtml: 'html',
  markdown: 'txt',
  md: 'txt',
  log: 'txt',
  conf: 'txt',
  cfg: 'txt',
  ini: 'txt',
  yml: 'txt',
  yaml: 'txt',
  ts: 'javascript',
  tsx: 'javascript',
  jsx: 'javascript',
  rar: 'zip',
  '7z': 'zip',
  tar: 'gz',
  tgz: 'gz',
  bz2: 'gz',
  mkv: 'mp4',
  mov: 'mp4',
  webm: 'mp4',
  m4a: 'mp3',
  aac: 'mp3',
  ogg: 'mp3',
  wma: 'wav',
  ps: 'psd',
  ai: 'ai',
  eps: 'ai',
  sketch: 'file',
  raf: 'raw',
  cr2: 'raw',
  cr3: 'raw',
  nef: 'raw',
  nrw: 'raw',
  arw: 'raw',
  srf: 'raw',
  sr2: 'raw',
  dng: 'raw',
  rw2: 'raw',
  orf: 'raw',
  pef: 'raw',
  rwl: 'raw',
  '3fr': 'raw',
  erf: 'raw',
  kdc: 'raw',
  mos: 'raw',
  mrw: 'raw',
  x3f: 'raw',
  dll: 'exe',
  bat: 'sh',
  cmd: 'sh',
  bash: 'sh',
  zsh: 'sh',
  fish: 'sh',
};

function extensionOf(name: string): string {
  const base = name.includes('/') ? name.slice(name.lastIndexOf('/') + 1) : name;
  if (base.startsWith('.') && !base.slice(1).includes('.')) {
    return '';
  }
  const dot = base.lastIndexOf('.');
  if (dot <= 0) {
    return '';
  }
  return base.slice(dot + 1).toLowerCase();
}

/** 資料夾用資料夾圖；檔案先對 alias 再對副檔名，都沒有就用通用檔案圖。 */
export function resolveEntryIcon(name: string, isDirectory: boolean): string {
  if (isDirectory) {
    return FOLDER_ICON;
  }
  const ext = extensionOf(name);
  if (!ext) {
    return FILE_FALLBACK;
  }
  const mapped = EXT_ALIASES[ext] || ext;
  if (iconByKey[mapped]) {
    return iconByKey[mapped];
  }
  // Direct match on full stem (e.g. "json-file")
  if (iconByKey[ext]) {
    return iconByKey[ext];
  }
  return FILE_FALLBACK;
}
